import React, {
    Fragment,
    useEffect,
    useRef,
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import { useNavigate } from 'react-router-dom';

import styled from 'styled-components';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';
import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import {
    almacenarAction
} from '../../../../actions/almacenarEjercicioActions';


// CSS GENERAL DE INFERENCIA

import {
    PantallaInferencia,
    BottomInferencia,
    NavegacionInferencia,
    BotonFinalizarInferencia
} from '../../../Css/StyledInferencia';


// =============================================================================
// INSTRUCCIONES
// =============================================================================

const instrucciones =
    'Observá cada imagen e inferí qué situación está ocurriendo.';


const miniInstrucciones =
    'Observá cada imagen e inferí qué situación está ocurriendo.';


// =============================================================================
// ESTILOS ESPECÍFICOS LEN38
// =============================================================================

const ZonaTarjetasLEN38 = styled.div`

    flex: 1;

    width: 100%;

    display: flex;

    align-items: center;
    justify-content: center;

    padding:
        clamp(
            20px,
            4vw,
            50px
        );

    overflow: auto;
`;


const ContenedorTarjetasLEN38 = styled.div`

    width: 100%;

    display: flex;

    align-items: center;
    justify-content: center;

    gap:
        clamp(
            18px,
            3vw,
            42px
        );

    flex-wrap: wrap;
`;


const TarjetaLEN38 = styled.button`

    width:
        clamp(
            190px,
            24vw,
            320px
        );

    aspect-ratio:
        1 / 1;

    padding: 0;

    border: none;

    background:
        transparent;

    perspective:
        1200px;

    cursor:
        ${props =>
            props.$disabled
                ? 'default'
                : 'pointer'
        };

    transition:
        transform 0.25s ease;


    &:hover {

        transform:
            ${props =>
                props.$disabled
                    ? 'none'
                    : 'translateY(-6px)'
            };
    }


    &:focus-visible {

        outline:
            3px solid
            #1F9E99;

        outline-offset:
            6px;

        border-radius:
            18px;
    }


    @media (max-width: 760px) {

        width:
            min(
                70vw,
                280px
            );
    }
`;


const GiroTarjetaLEN38 = styled.div`

    position: relative;

    width: 100%;
    height: 100%;

    transform-style: preserve-3d;

    -webkit-transform-style: preserve-3d;

    transition:
        transform
        0.7s
        cubic-bezier(
            0.4,
            0.2,
            0.2,
            1
        );

    transform:
        ${props =>
            props.$girada
                ? 'rotateY(180deg)'
                : 'rotateY(0deg)'
        };

    -webkit-transform:
        ${props =>
            props.$girada
                ? 'rotateY(180deg)'
                : 'rotateY(0deg)'
        };
`;


const CaraTarjetaLEN38 = styled.div`

    position:
        absolute;

    inset:
        0;

    border-radius:
        clamp(
            14px,
            1.6vw,
            18px
        );

    backface-visibility:
        hidden;

    -webkit-backface-visibility:
        hidden;

    overflow:
        hidden;
`;


const DorsoTarjetaLEN38 = styled(CaraTarjetaLEN38)`

    background:
        #1F9E99;

    display:
        flex;

    align-items:
        center;

    justify-content:
        center;

    transform:
        rotateY(0deg)
        translateZ(1px);

    -webkit-transform:
        rotateY(0deg)
        translateZ(1px);

    backface-visibility:
        hidden;

    -webkit-backface-visibility:
        hidden;

    box-shadow:
        0 4px 14px
        rgba(
            0,
            0,
            0,
            0.12
        );


    &::before {

        content:
            '';

        position:
            absolute;

        inset:
            12px;

        border-radius:
            11px;

        border:
            3px solid
            rgba(
                255,
                255,
                255,
                0.55
            );
    }
`;


const LogoTarjetaLEN38 = styled.img`

    position: relative;

    z-index: 2;

    width: 36%;

    height: auto;

    object-fit: contain;

    user-select: none;

    pointer-events: none;
`;


const FrenteTarjetaLEN38 = styled(CaraTarjetaLEN38)`

    transform:
        rotateY(180deg)
        translateZ(1px);

    -webkit-transform:
        rotateY(180deg)
        translateZ(1px);

    backface-visibility:
        hidden;

    -webkit-backface-visibility:
        hidden;

    background:
        #FFFFFF;

    border:
        1px solid
        #DDDDDD;

    box-shadow:
        0 4px 14px
        rgba(
            0,
            0,
            0,
            0.08
        );

    display:
        flex;

    align-items:
        center;

    justify-content:
        center;


    img {

        display:
            block;

        width:
            100%;

        height:
            100%;

        object-fit:
            contain;

        user-select:
            none;

        -webkit-user-drag:
            none;
    }
`;


// =============================================================================
// LEN38
// =============================================================================

const LEN38 = () => {


    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [config] =
        useConfigAuth();


    // -------------------------------------------------------------------------
    // REGISTRO ACTUAL
    // -------------------------------------------------------------------------

    const [
        comparar,
        setComparar
    ] = useState(null);


    // -------------------------------------------------------------------------
    // TARJETAS GIRADAS
    // -------------------------------------------------------------------------

    const [
        giradas,
        setGiradas
    ] = useState([
        false,
        false,
        false
    ]);


    const [
        disable,
        setDisable
    ] = useState(false);


    // =========================================================================
    // TIEMPOS
    //
    // Ahora las tres imágenes están visibles al mismo tiempo.
    //
    // Para mantener el mismo formato de almacenamiento:
    // tiempo[0] = tiempo que estuvo abierta tarjeta 1
    // tiempo[1] = tiempo que estuvo abierta tarjeta 2
    // tiempo[2] = tiempo que estuvo abierta tarjeta 3
    //
    // Si vuelve a tapar una tarjeta y luego la abre otra vez,
    // el tiempo nuevo se suma al anterior.
    // =========================================================================

    const tiemposRef =
        useRef([
            0,
            0,
            0
        ]);


    const inicioTarjetasRef =
        useRef([
            null,
            null,
            null
        ]);


    // =========================================================================
    // REDUX
    // =========================================================================

    const iniciar =
        useSelector(
            state =>
                state.ejercicio.iniciar
        );


    const finalizar =
        useSelector(
            state =>
                state.ejercicio.finalizar
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const informacion =
        useSelector(
            state =>
                state.informacion.info_DB
        );


    const lista_usada =
        useSelector(
            state =>
                state.informacion.lista_usada
        );


    const sesion =
        useSelector(
            state =>
                state.ejercicio.sesion
        );


    // =========================================================================
    // CONFIGURACIÓN INICIAL
    // =========================================================================

    useEffect(() => {


        dispatch(
            setearEjercicioAction(
                'LEN38'
            )
        );


        dispatch(
            setearUrlAnteriorAction(
                'lenguaje/inferencia/'
            )
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================================
    // RECIBIMOS UN SOLO REGISTRO
    //
    // Ese registro contiene:
    //
    // imagen_url_1
    // imagen_url_2
    // imagen_url_3
    // =========================================================================

    useEffect(() => {


        if (
            !Array.isArray(
                informacion
            ) ||
            informacion.length ===
                0
        ) {

            return;
        }


        setComparar(
            informacion[0]
        );


        /*
        Cada ejercicio nuevo comienza
        con las tres tarjetas tapadas.
        */

        setGiradas([
            false,
            false,
            false
        ]);


        tiemposRef.current = [
            0,
            0,
            0
        ];


        inicioTarjetasRef.current = [
            null,
            null,
            null
        ];


        setDisable(
            false
        );


    }, [
        informacion
    ]);


    // =========================================================================
    // GIRAR TARJETA
    // =========================================================================

    const girarTarjeta = (
        index
    ) => {


        if (
            disable ||
            !comparar
        ) {

            return;
        }


        const ahora =
            Date.now();


        const nuevasGiradas = [
            ...giradas
        ];


        // ---------------------------------------------------------------------
        // SI ESTABA ABIERTA:
        // cerramos el tiempo de visualización
        // ---------------------------------------------------------------------

        if (
            giradas[index]
        ) {


            if (
                inicioTarjetasRef
                    .current[index] !==
                null
            ) {


                const segundos =
                    (
                        ahora -
                        inicioTarjetasRef
                            .current[index]
                    ) /
                    1000;


                tiemposRef
                    .current[index] +=
                    segundos;
            }


            inicioTarjetasRef
                .current[index] =
                null;


            nuevasGiradas[index] =
                false;


        } else {


            // -----------------------------------------------------------------
            // SI ESTABA TAPADA:
            // comienza el tiempo de visualización
            // -----------------------------------------------------------------

            inicioTarjetasRef
                .current[index] =
                ahora;


            nuevasGiradas[index] =
                true;
        }


        setGiradas(
            nuevasGiradas
        );
    };


    // =========================================================================
    // CERRAR TIEMPOS QUE SIGAN ABIERTOS
    // =========================================================================

    const registrarTiemposAbiertos = () => {


        const ahora =
            Date.now();


        inicioTarjetasRef
            .current
            .forEach(
                (
                    inicio,
                    index
                ) => {


                    if (
                        inicio ===
                        null
                    ) {

                        return;
                    }


                    const segundos =
                        (
                            ahora -
                            inicio
                        ) /
                        1000;


                    tiemposRef
                        .current[index] +=
                        segundos;


                    /*
                    Lo dejamos en null
                    para no sumar dos veces.
                    */

                    inicioTarjetasRef
                        .current[index] =
                        null;
                }
            );
    };


    // =========================================================================
    // FINALIZAR
    // =========================================================================

    const terminar = (
        e
    ) => {


        e.preventDefault();


        if (
            disable ||
            !comparar
        ) {

            return;
        }


        setDisable(
            true
        );


        /*
        Antes de terminar sumamos
        el tiempo de cualquier tarjeta
        que todavía esté mostrando
        su imagen.
        */

        registrarTiemposAbiertos();


        dispatch(
            finalizarEjercicioAction()
        );
    };


    // =========================================================================
    // ALMACENAR
    // =========================================================================

    useEffect(() => {


        if (
            !finalizar
        ) {

            return;
        }


        const tiempoFinal =
            tiemposRef.current.map(
                tiempo =>
                    Math.round(
                        tiempo *
                        10
                    ) /
                    10
            );


        const informacionGuardar = {


            config,


            payload: {


                ejercicio:
                    'LEN38',


                errores:
                    0,


                tiempo:
                    tiempoFinal,


                id_paciente,


                lista_usada,


                sesion
            }
        };


        dispatch(
            almacenarAction(
                informacionGuardar
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        finalizar
    ]);


    // =========================================================================
    // IMÁGENES
    // =========================================================================

    const imagenes =
        comparar

            ? [

                comparar
                    .imagen_url_1,

                comparar
                    .imagen_url_2,

                comparar
                    .imagen_url_3

            ]

            : [];


    // =========================================================================
    // RENDER
    // =========================================================================

    return (


        <Fragment>


            <HeaderEjercicios
                estrellas={
                    true
                }
                carrito={
                    true
                }
            />


            {

                iniciar

                    ? (


                        <PantallaInferencia>


                            {/* ================================================= */}
                            {/* TRES TARJETAS                                      */}
                            {/* ================================================= */}

                            <ZonaTarjetasLEN38>


                                <ContenedorTarjetasLEN38>


                                    {
                                        imagenes.map(
                                            (
                                                imagen,
                                                index
                                            ) => (


                                                <TarjetaLEN38
                                                    key={
                                                        index
                                                    }
                                                    type="button"
                                                    $disabled={
                                                        disable
                                                    }
                                                    disabled={
                                                        disable
                                                    }
                                                    aria-label={
                                                        giradas[index]

                                                            ?
                                                            `Tapar imagen ${index + 1}`

                                                            :
                                                            `Mostrar imagen ${index + 1}`
                                                    }
                                                    aria-pressed={
                                                        giradas[index]
                                                    }
                                                    onClick={
                                                        () =>
                                                            girarTarjeta(
                                                                index
                                                            )
                                                    }
                                                >


                                                    <GiroTarjetaLEN38
                                                        $girada={
                                                            giradas[
                                                                index
                                                            ]
                                                        }
                                                    >


                                                        {/* ================================= */}
                                                        {/* DORSO                            */}
                                                        {/* ================================= */}

                                                        <DorsoTarjetaLEN38>

                                                            <LogoTarjetaLEN38
                                                                src="/img/logo_yogen_blanco.svg"
                                                                alt=""
                                                                draggable={false}
                                                            />

                                                        </DorsoTarjetaLEN38>


                                                        {/* ================================= */}
                                                        {/* FRENTE                           */}
                                                        {/* ================================= */}

                                                        <FrenteTarjetaLEN38>


                                                            {
                                                                imagen && (


                                                                    <img
                                                                        src={
                                                                            `/img/${imagen}.png`
                                                                        }
                                                                        alt=""
                                                                        draggable={
                                                                            false
                                                                        }
                                                                    />


                                                                )
                                                            }


                                                        </FrenteTarjetaLEN38>


                                                    </GiroTarjetaLEN38>


                                                </TarjetaLEN38>


                                            )
                                        )
                                    }


                                </ContenedorTarjetasLEN38>


                            </ZonaTarjetasLEN38>


                            {/* ================================================= */}
                            {/* BARRA INFERIOR                                     */}
                            {/* ================================================= */}

                            <BottomInferencia>


                                <BotoneraBottom
                                    miniInstrucciones={
                                        miniInstrucciones
                                    }
                                />


                                <NavegacionInferencia>


                                    {/*
                                    Ya no hay:

                                    - anterior
                                    - siguiente

                                    Este botón solamente
                                    FINALIZA el ejercicio.
                                    */}

                                    <BotonFinalizarInferencia
                                        type="button"
                                        disabled={
                                            disable
                                        }
                                        onClick={
                                            terminar
                                        }
                                        aria-label="Finalizar"
                                    >


                                        <img
                                            alt=""
                                            src="/img/icono_avanzar_ninos.png"
                                        />


                                    </BotonFinalizarInferencia>


                                </NavegacionInferencia>


                            </BottomInferencia>


                        </PantallaInferencia>


                    )

                    : (


                        <Instrucciones
                            instrucciones={
                                instrucciones
                            }
                        />


                    )
            }


        </Fragment>
    );
};


export default LEN38;